// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"90":"7486d3bb","332":"675181de","433":"b38b2697","483":"6ea3c48a","726":"fc4cc641","846":"9aaad01e","893":"203d09a9"}[chunkId] + ".chunk.js";
};